import React from 'react'
import { Breadcrumb, Container } from 'reactstrap'
import List from '../../../DisputeWorkFlow/pages/DisputeList/component/List'

const MenuListPage = () => {
  return (
   <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumb title="Project List" pageTitle="Projects" />
                    <List />
                </Container>
            </div>
        </React.Fragment>
  )
}

export default MenuListPage
